/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-22 14:31:51
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-04-12 15:23:50
 * @FilePath: /dsicm-admin-web/src/views/OrderManagement/api/orderPay.js
 */
//引入接口文档
import req from '@/utils/req.js'

//根据类型获取问诊服务
export function getServiceByType(params) {
  return req.get('/admin/inquiry-service/getServiceByType', params)
}
//订单主表列表查询
export function getOrderList(params) {
  return req.post('/admin/order/page', params)
}
//订单主表详细查询
export function getOrderDetails(params) {
  return req.get(`/admin/order/${params}`)
}
//电子处方分页查询
export function searchPrescription(params) {
  return req.post(`/admin/elec-prescription/search`, params)
}
//电子处方详细查询
export function prescriptionDetails(params) {
  return req.get(`/admin/elec-prescription/${params}`)
}
//订单状态修改为退款
export function prescriptionRefund(params) {
  return req.post(`/admin/order-pay/refund`, params,{loading:true})
}
//待支付订单消息提醒
export function reminder(params) {
  return req.post(`/admin/order/order/payment/reminder`, params)
}

//通过订单编号查询物流信息
export function orderNo(params) {
  return req.get(`/admin/logistics/order-no`, params)
}

//获取物流信息接口
export function logisticsInfo(params) {
  return req.get(`/admin/zyy/query-logistics-info`, params)
}
//推送购药提醒

export function pushPurchaseRemind(params) {
  return req.get(`/admin/elec-prescription/pushPurchaseRemind`, params)
}
export function remindApproval(id) {
  return req.put(`/admin/elec-prescription/${id}/remindApproval`)
}

export function getDoctorPage(params) {
  return req.post(`/admin/order/page`, params)
}
export function getDoctorDetail(params) {
  return req.get(`/admin/order/${params}`)
}


// 获取全部订单汇总记录
export function queryOrderSumRecord(params) {
  return req.post(`/admin/order/queryOrderSumRecord`, params)
}

// 根据订单类型等字段查询订单记录
export function queryOrderByOrderTypeAndPlatformIdAndTime(params) {
  return req.post(`/admin/order/queryOrderByOrderTypeAndPlatformIdAndTime`, params)
}

// 导出订单汇总记录
export function exportOrderSumRecord(params) {
  return req.postUpload(`/admin/order/exportOrderSumRecord`, params, { responseType:'arraybuffer' })
}

// 医院平台列表
export function getPlatformList(params) {
  return req.post(`/admin/platform/list`, params)
}



/**
 * 商品支付管理
 */

// 物流上报 /logistics
export function logisticsPost(params) {
  return req.post(`/admin/logistics`, params)
}
// 物流公司 /logistics-company-code/getListByName
export function getListByLogisticsName(params) {
  return req.get(`/biz/logistics-company-code/getListByName`, params)
}

// 批量物流上报
export function logisticsBatchPost(params) {
  return req.post(`/admin/logistics/add-list`, params)
}

// 物流删除
export function logisticsDelete(id) {
  return req.delete(`/admin/logistics/${id}`)
}

// 通过订单编号查询物流信息
export function getLogisticsByOrderNo(params) {
  return req.get(`/admin/logistics/order-detail-id`, params)
}

// 协同订单 
export function getSynergyOrderPage(params) {
  return req.post('/biz/synergy-order/manager/page', params)
}

// 协同订单详情
export function getSynergyOrderDetails(params) {
  return req.get(`/biz/synergy-order/manager/detail/${params}`)
}

// 通过支付时间导出商品订单收件信息 
export function exportGoodsAddress(params) {
  return req.postUpload('/admin/order/exportGoodsAddress', params,{ responseType:'arraybuffer' })
}

// 通过物流节点获取物流信息
export function getQueryTrackResp(id) {
  return req.get(`/admin/logistics/queryTrackResp/${id}`)
}
